import { render, staticRenderFns } from "./SaldoDisplay.vue?vue&type=template&id=b754885c&scoped=true"
import script from "./SaldoDisplay.vue?vue&type=script&lang=js"
export * from "./SaldoDisplay.vue?vue&type=script&lang=js"
import style0 from "./SaldoDisplay.vue?vue&type=style&index=0&id=b754885c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b754885c",
  null
  
)

export default component.exports